module.exports = __webpack_public_path__ + "static/media/epayIcon.d01d5e94.svg";